module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "md-tabs",
    class: _vm.tabClasses
  }, [_vm._h('md-whiteframe', {
    attrs: {
      "md-elevation": _vm.elevation || 0
    }
  }, [_vm._h('div', {
    staticClass: "md-tabs-navigation"
  }, [_vm._l((_vm.tabs), function(header) {
    return _vm._h('button', {
      directives: [{
        name: "md-ink-ripple",
        rawName: "v-md-ink-ripple",
        value: (header.disabled),
        expression: "header.disabled"
      }],
      key: header.id,
      ref: "tabHeader",
      refInFor: true,
      staticClass: "md-tab-header",
      class: _vm.getHeaderClass(header),
      attrs: {
        "type": "button",
        "disabled": header.disabled
      },
      on: {
        "click": function($event) {
          _vm.changeTab(header.id)
        }
      }
    }, [_vm._h('div', {
      staticClass: "md-tab-header-container"
    }, [(header.icon) ? _vm._h('md-icon', [_vm._s(header.icon)]) : _vm._e(), " ", (header.label) ? _vm._h('span', [_vm._s(header.label)]) : _vm._e()])])
  }), " ", _vm._h('span', {
    ref: "indicator",
    staticClass: "md-tab-indicator",
    class: _vm.indicatorClass
  })])]), " ", _vm._h('div', {
    ref: "tabContent",
    staticClass: "md-tabs-content"
  }, [_vm._h('div', {
    ref: "tabWrapper",
    staticClass: "md-tabs-wrapper"
  }, [_vm._t("default")])])])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c28dc5a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c28dc5a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mdTabs/mdTabs.vue
// module id = 186
// module chunks = 18 22